import React from "react";

import { Splash as SplashComponent } from "ui/components";
import { useAppContext } from "ui/hooks";

export interface ISplashProps {
  statusText?: string;
  additionalStatusText?: string;
}

export const Splash: React.FC<ISplashProps> = ({ statusText, additionalStatusText }) => {
  const appInfo = useAppContext().appInfo;

  return <SplashComponent appName={appInfo.appName} statusText={statusText} additionalStatusText={additionalStatusText} />;
};
